import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hjb-photo-carousel',
  templateUrl: './photo-carousel.component.html',
  styleUrls: ['./photo-carousel.component.scss']
})
export class PhotoCarouselComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
